import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setStoredUser, getStoredUser, logout as wipeAuth } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const cached = getStoredUser();
  const [user, setUser] = useState(cached);
  // If we have a cached user profile we optimistically render; otherwise we
  // show a loading state while /auth/me confirms (or denies) the session.
  const [loading, setLoading] = useState(!cached);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setStoredUser(data.user);
    } catch {
      setStoredUser(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    // Backend sets the httpOnly cookie via Set-Cookie on this response;
    // we don't touch the JWT from JS at all.
    const { data } = await api.post("/auth/login", { email, password });
    setStoredUser(data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await wipeAuth();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
